var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { class: [_vm.iconClass, _vm.fillClass], style: _vm.iconStyle },
      _vm.$listeners
    ),
    [
      _c("use", {
        attrs: {
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xlink:href": _vm.iconName
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }